;(function ($) {
	'use strict';

	$(window).on('load', init_utility);
	$(window).on('resize', init_utility);

	function init_utility() {
		const isDesktop = $('.main-menu__toggle').css('display') === 'none';

		$('.account-menu-toggle--desktop, .resources-menu-toggle--desktop')
			.parent()
			.off('mouseenter.menuUtility mouseleave.menuUtility');

		// Mobile behavior only runs in mobile view.
		if (!isDesktop) {
			click_action('.header__navigation--utility.mobile .utility-toggle');

			$('.utility-toggable__close').off('click.menuUtility').on('click.menuUtility', function () {
				$(this).parents('.utility-toggable').prev('.utility-toggle').trigger('click');
			});
		}
		else {
			// Desktop behavior only runs in desktop view.
			mouse_action('.account-menu-toggle--desktop');
			click_action('.account-menu-toggle--desktop');

			mouse_action('.resources-menu-toggle--desktop');
			click_action('.resources-menu-toggle--desktop');
		}

		search_action();
	}

	function mouse_action(el) {
		$(el).parent().on({
			'mouseenter.menuUtility': function() {
				$(this).attr('aria-expanded', true);
				$(this).find('.utility-toggable').show();
			},
			'mouseleave.menuUtility': function() {
				$(this).attr('aria-expanded', false);
				$(this).find('.utility-toggable').hide();
			}
		});
	}

	function click_action(el) {
		const isDesktop = $('.main-menu__toggle').css('display') === 'none';

		$(el).off('click.menuUtility').on('click.menuUtility', function () {
			if (!$(this).hasClass('active')) {
				// Close all other open toggles
				$('.utility-toggle').not(this)
					.removeClass('active')
					.next('.utility-toggable').hide();

				$('.utility-toggle').not(this)
					.parent().attr('aria-expanded', false);

				$('.utility-toggle--desktop').not(this)
					.removeClass('active')
					.next('.utility-toggable').hide();

				$('.utility-toggle--desktop').not(this)
					.parent().attr('aria-expanded', false);

				// Mobile behavior only runs in mobile view.
				if (!isDesktop) {
					$('.search-toggle.active').trigger('click');
				}
			}

			$(this).toggleClass('active')
				.next('.utility-toggable').toggle();

			const $parent = $(this).parent();
			$parent.attr('aria-expanded', $parent.attr('aria-expanded') === 'true' ? false : true);
		});
	}

	function search_action() {
		$('.search-toggle').off('click').on('click', function() {
			const isDesktop = $('.main-menu__toggle').css('display') === 'none';
			let target = $(window).scrollTop();

			if ( !$(this).hasClass('active') ) {
				$(this).addClass('active');

				$('.search-toggable').show();

				$('body').addClass('search-is-open')
					.attr('draggable', false);

				if (target == 0 && isDesktop) {
					window.scrollBy(0, 1);
				}

				if (!isDesktop) {
					$('.utility-toggle.active').trigger('click');
					$('.header__toggable--main__wrapper').hide();
				}
			}
			else {
				$(this).removeClass('active');

				$('.search-toggable').hide();

				$('body').removeClass('search-is-open')
					.attr('draggable', true);

				if (target == 1 && isDesktop) {
					window.scrollTo(0, 0);
				}

				$('.header__toggable--main__wrapper').show();
			}

			const $parent = $(this).parent();
			$parent.attr('aria-expanded', $parent.attr('aria-expanded') === 'true' ? false : true);
		});

		$('.search-toggable__close').off('click').on('click', function() {
			$('.search-toggle.active').trigger('click');
		});
	}

})(jQuery);
